/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{width:100%}[_nghost-%COMP%]   .form[_ngcontent-%COMP%]{width:100%;border-radius:.3333333333em;border:1px solid #d5d7e0;background-color:#fff;display:flex;align-items:center;justify-content:space-between;padding:.5833333333em 1.1666666667em}[_nghost-%COMP%]   .form-locked[_ngcontent-%COMP%]{outline:0;border:none;background-color:transparent}"];
export { styles as styles };
